/**
 * Block fbq('init') for stray pixels (Cloudflare / agency).
 * Enabled in production by default; set REACT_APP_META_PIXEL_GUARD=false to disable.
 */
import { isBlockedMetaPixelId, isMetaPixelAllowedOnCurrentHost } from '../config/metaPixel';

const PATCH_FLAG = '__daivMetaPixelCallMethodPatched';

function scrubQueueInPlace(queue) {
  if (!Array.isArray(queue)) return;
  for (let i = queue.length - 1; i >= 0; i -= 1) {
    const args = queue[i];
    if (args?.[0] === 'init' && isBlockedMetaPixelId(args[1])) {
      queue.splice(i, 1);
    }
  }
}

function patchCallMethod(fbq) {
  if (!fbq || fbq[PATCH_FLAG]) return;

  let current = fbq.callMethod;
  try {
    Object.defineProperty(fbq, 'callMethod', {
      configurable: true,
      enumerable: true,
      get() {
        return current;
      },
      set(next) {
        if (typeof next !== 'function') {
          current = next;
          return;
        }
        const orig = next;
        current = function callMethod(...args) {
          if (args[0] === 'init' && isBlockedMetaPixelId(args[1])) return undefined;
          return orig.apply(this, args);
        };
      },
    });
    if (typeof current === 'function') {
      const orig = current;
      current = function callMethod(...args) {
        if (args[0] === 'init' && isBlockedMetaPixelId(args[1])) return undefined;
        return orig.apply(this, args);
      };
    }
    fbq[PATCH_FLAG] = true;
  } catch {
    /* ignore */
  }
}

export function installMetaPixelGuard() {
  if (typeof window === 'undefined' || !isMetaPixelAllowedOnCurrentHost()) return;
  const disabled = process.env.REACT_APP_META_PIXEL_GUARD === 'false';
  const enabled =
    process.env.REACT_APP_META_PIXEL_GUARD === 'true' ||
    (!disabled && process.env.NODE_ENV === 'production');
  if (!enabled) return;
  if (window.__daivMetaPixelGuardInstalled) return;
  window.__daivMetaPixelGuardInstalled = true;

  scrubQueueInPlace(window.fbq?.queue);
  patchCallMethod(window.fbq);

  let ticks = 0;
  const timer = window.setInterval(() => {
    ticks += 1;
    scrubQueueInPlace(window.fbq?.queue);
    patchCallMethod(window.fbq);
    if (ticks > 200) window.clearInterval(timer);
  }, 50);
}
